import { BetTitleGroup } from './types/BetTitleGroup';

const betTitleGroups: BetTitleGroup[] = [
	{
		title: 'Популярные',
		codes: [
			101, 102, 103, 804, 854, 806, 856, 252, 254, 552, 554, 206, 208, 506, 508, 306, 308, 606, 608,
			1101, 1151,
		],
	},
	{
		title: 'Результат матча + Тотал голов',
		subgroups: [
			{
				title: 'Результат матча',
				range: [101, 200],
			},
			{
				title: 'П1 + Тотал меньше',
				range: [201, 250],
			},
			{
				title: 'П1 + Тотал больше',
				range: [251, 300],
			},
			{
				title: 'Х + Тотал меньше',
				range: [401, 450],
			},
			{
				title: 'Х + Тотал больше',
				range: [451, 500],
			},
			{
				title: 'П2 + Тотал меньше',
				range: [501, 550],
			},
			{
				title: 'П2 + Тотал больше',
				range: [551, 600],
			},
			{
				title: '1Х + Тотал меньше',
				range: [301, 350],
			},
			{
				title: '1Х + Тотал больше',
				range: [351, 400],
			},
			{
				title: 'Х2 + Тотал меньше',
				range: [601, 650],
			},
			{
				title: 'Х2 + Тотал больше',
				range: [651, 700],
			},
			{
				title: '12 + Тотал меньше',
				range: [701, 750],
			},
			{
				title: '12 + Тотал больше',
				range: [751, 800],
			},
		],
	},
	{
		title: 'Счёт матча',
		subgroups: [
			{
				title: 'Счета от 0:0 до 3:3',
				range: [1201, 1250],
			},
			{
				title: 'Прочие счета',
				range: [1251, 1300],
			},
		],
	},
	{
		title: 'Точный счёт (по таймам)',
		subgroups: [
			{
				title: '1й тайм',
				range: [2201, 2250],
			},
			{
				title: '2й тайм',
				range: [2251, 2300],
			},
		],
	},
	{
		title: 'Тайм / Матч',
		range: [2101, 2150],
	},
	{
		title: '1й тайм / 2й тайм',
		range: [2151, 2200],
	},
	{
		title: 'Таймы',
		subgroups: [
			{
				title: 'Результат тайма',
				range: [2001, 2100],
			},
			{
				title: 'Обе забьют + Результат тайма',
				range: [2301, 2400],
			},
			{
				title: 'Фора - Хозяева, 1й тайм',
				range: [2401, 2450],
			},
			{
				title: 'Фора - Хозяева, 2й тайм',
				range: [2501, 2550],
			},
			{
				title: 'Фора - Гости, 1й тайм',
				range: [2451, 2500],
			},
			{
				title: 'Фора - Гости, 2й тайм',
				range: [2551, 2600],
			},
			{
				title: 'Хозяева, Тотал голов - 1й тайм',
				range: [2801, 2900],
			},
			{
				title: 'Хозяева, Тотал голов - 2й тайм',
				range: [2901, 3000],
			},
			{
				title: 'Гости, Тотал голов - 1й тайм',
				range: [3001, 3100],
			},
			{
				title: 'Гости, Тотал голов - 2й тайм',
				range: [3101, 3200],
			},
			{
				title: '1й тайм - Результат + ТМ',
				range: [3201, 3300],
			},
			{
				title: '1й тайм - Результат + ТБ',
				range: [3301, 3400],
			},
			{
				title: '2й тайм - Результат + ТМ',
				range: [3401, 3500],
			},
			{
				title: '2й тайм - Результат + ТБ',
				range: [3501, 3600],
			},
			{
				title: 'Тайм с большим кол-вом голов',
				range: [3601, 3700],
			},
		],
	},
	{
		title: 'Тоталы',
		subgroups: [
			{
				title: 'Тотал меньше',
				range: [801, 850],
			},
			{
				title: 'Тотал больше',
				range: [851, 900],
			},
		],
	},
	{
		title: 'Форы',
		codes: [1101, 1151],
		subgroups: [
			{
				title: 'Фора - хозяева (минус)',
				codes: [1102, 1104, 1106, 1108, 1110, 1112, 1114, 1116, 1118, 1120, 1122],
			},
			{
				title: 'Фора - хозяева (плюс)',
				codes: [1103, 1105, 1107, 1109, 1111, 1113, 1115, 1117, 1119, 1121, 1123],
			},
			{
				title: 'Фора - гости (минус)',
				codes: [1152, 1154, 1156, 1158, 1160, 1162, 1164, 1166, 1168, 1170, 1172],
			},
			{
				title: 'Фора - гости (плюс)',
				codes: [1153, 1155, 1157, 1159, 1161, 1163, 1165, 1167, 1169, 1171, 1173],
			},
		],
	},
	{
		title: 'Результат матча + Обе забьют',
		range: [1401, 1450],
	},
	{
		title: 'Голы',
		range: [1301, 1350],
		subgroups: [
			{
				title: 'Голы (по таймам)',
				range: [1351, 1400],
			},
			{
				title: 'Обе забьют + Тотал меньше',
				range: [1501, 1550],
			},
			{
				title: 'Обе забьют + Тотал больше',
				range: [1551, 1600],
			},
			{
				title: 'Любая забьет больше Х голов',
				range: [1451, 1500],
			},
		],
	},
	{
		title: 'Тоталы (по таймам)',
		subgroups: [
			{
				title: 'Тотал меньше - 1й тайм',
				range: [2601, 2650],
			},
			{
				title: 'Тотал больше - 1й тайм',
				range: [2651, 2700],
			},
			{
				title: 'Тотал меньше - 2й тайм',
				range: [2701, 2750],
			},
			{
				title: 'Тотал больше - 2й тайм',
				range: [2751, 2800],
			},
		],
	},
	{
		title: 'Победа всухую',
		codes: [5001, 5002, 5003],
	},
	{
		title: 'Победа с точной разницей голов',
		codes: [5101, 5103, 5105, 5102, 5104, 5106, 5107, 5108, 5109],
	},
	{
		title: 'Особые ставки',
		subgroups: [
			{
				title: 'События в плей-офф',
				range: [5201, 5300],
			},
		],
	},
	{
		title: 'Инд. тотал хозяев',
		range: [901, 1000],
	},
	{
		title: 'Инд. тотал гостей',
		range: [1001, 1100],
	},
];
export default betTitleGroups;
